const FIELD_LABELS: Record<string, string> = {
	// common
	state: 'Status',
	watched: 'Viewed',
	paid: 'Paid',
	deposit: 'Deposit',
	charge_id: 'Charge ID',

	// customer
	discount: 'Discount',
	bedroom: 'Bedrooms',
	movers: 'Movers',
	packing: 'Packing',
	payment: 'Payment method',
	time: 'Start time',
	truck: 'Truck',
	typeofresidency: 'Type of residence',
	customer_name: 'Customer name',
	customer_phone: 'Customer phone',
	customer_email: 'Customer email',

	// foreman
	loading_time: 'Loading time',
	unloading_time: 'Unloading time',
	drive_time: 'Drive time',
	workers_count: 'Workers count',
	total: 'Total',
	notes: 'Notes'
};

export function humanizeKey(chainKey: string): string {
	// normalize
	const clean = chainKey
		.replace(/^acf\./, '')
		.replace(/^customer_info\./, '')
		.replace(/^foreman_info\./, '');

	const parts = clean.split('.');
	const lastKey = parts[parts.length - 1];

	// ---- Address special cases ----
	const isPickup = parts.includes('pickup_address');
	const isDropoff = parts.includes('dropoff_address');

	if ((isPickup || isDropoff) && ['full_address', 'unit', 'zip'].includes(lastKey)) {
		const prefix = isPickup ? 'Pickup' : 'Drop-off';

		if (lastKey === 'full_address') {return `${prefix} Address`;}
		if (lastKey === 'unit') {return `${prefix} Unit`;}
		if (lastKey === 'zip') {return `${prefix} ZIP`;}
	}

	// ---- Dictionary mapping ----
	if (FIELD_LABELS[lastKey]) {
		return FIELD_LABELS[lastKey];
	}

	// ---- Fallback: snake_case → Title Case ----
	return lastKey
		.replace(/_/g, ' ')
		.replace(/\b\w/g, (c) => c.toUpperCase());
}